const ContactPage = () => {
  return (
    <div>
      <h6>Contact Page - modal?</h6>
    </div>
  );
};

export default ContactPage;
